import type { MediaAsset } from '@/types/news';

type ArticleGalleryProps = {
  items: MediaAsset[];
};

export function ArticleGallery({ items }: ArticleGalleryProps) {
  if (items.length === 0) return null;

  return (
    <section aria-label="Galería" className="space-y-3">
      <h2 className="text-lg font-semibold">Galería</h2>
      <div className="flex snap-x gap-3 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map((item) => (
          <figure key={item.id} className="min-w-[82%] snap-start overflow-hidden rounded bg-divergent-panel">
            {item.type === 'image' ? (
              <img src={item.url} alt={item.alt} className="aspect-[4/3] w-full object-cover" loading="lazy" />
            ) : (
              <video src={item.url} className="aspect-[4/3] w-full object-cover" controls preload="metadata" />
            )}
            <figcaption className="px-3 py-2 text-xs text-white/55">{item.alt}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
